import { css } from '@emotion/core';
/* eslint-disable import/prefer-default-export */

export var container = {
  name: "7boy05",
  styles: "position:relative;display:flex;align-items:center;"
};